/*
 * @Author: caiqin.xie
 * @since: 2023-08-14 19:23:26
 * @lastTime: 2024-01-15 16:04:59
 * @LastEditors: caiqin.xie
 * @message: 维修价格-配件价格表
 */
import React, { useState, useEffect }  from "react";
import styles from "../../index.module.scss";
import classNames from "classnames";
interface IList{
  [key:string]: any
  paramBOs: Record<string, string>[];
}
interface IProps {
  ctry: string;
  words: Record<string, string>;
  priceList: IList[]; // 维修价格表
}

const SparePartsPrice = (props:IProps) => {
  const {ctry, words, priceList} = props
  const [isShowLowerPrice, setIsShowLowerPrice] = useState<boolean>(false) // 是否显示最低价

  useEffect(() => {
    if(priceList && priceList.length > 0) {
      let paramBOsList = priceList.flatMap(item => item.paramBOs)
      let lowerPriceList = paramBOsList.map((item: Record<string, any>) => item.price ? item.price : '')
      let flag = lowerPriceList.some(item => item !== '')
      setIsShowLowerPrice(flag)
    }
  }, [priceList])

  return (
    <>
      {priceList && priceList.length > 0 && (
        <>
          <h2 className={styles['price_title']}>
            {words?.support_maintenance_price_table_title}
            {/* Charging standards for spare parts prices */}
          </h2>
          <ul className={classNames(styles["price-table"], {
            [styles["price-table-s"]]: isShowLowerPrice
          })}>
            <li className={`${styles["table-item"]} ${styles["table-item-title"]}`}>
              <span className={styles["table-item-label"]}>
                {words?.support_maintenance_price_sparePart_type}
                {/* Type of spare parts */}
              </span>
              <span className={styles["table-item-label"]}>
                {words?.support_maintenance_price_sparePart_name}
                {/* Spare part name */}
              </span>
              <span className={styles["table-item-label"]}>
                {words?.support_maintenance_price_suggest_price}
                {/* Suggested retail price */}
              </span>
              {isShowLowerPrice && (
                <span className={styles["table-item-label"]}>
                  {words?.support_maintenance_price_suggest_lower_price}
                </span>
              )}
            </li>
            {priceList && priceList.map((item, index) => (
              <li className={styles["table-item"]} key={index}>
                <div className={`${styles["table-item-label"]} ${styles["algin-center"]}`}>
                  <span className={styles["full-width"]}>{item.name}</span>
                </div>
                <div className={styles["table-item-content"]}>
                  {item.paramBOs && item.paramBOs.map((listItem, listIndex) => (
                    <div className={styles["full-width"]} key={listIndex}>
                      <span className={styles["table-item-label"]}>{listItem.name}</span>
                      <span className={styles["table-item-label"]}>{listItem.value}</span>
                      {isShowLowerPrice && (
                        <span className={styles["table-item-label"]}>{listItem.price}</span>
                      )}
                    </div>
                  ))}
                </div>
              </li>
            ))}
          </ul>
        </>
      )}
    </>
    
  )
}
export default SparePartsPrice